export default "__VITE_ASSET__BtBIUkg2__"